import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { FrameName } from "../config";
import { UpgradeIds } from "../config/upgrades";
import TileEntity from "../TileEntity";

type FishingBoatFrameNames =
	| FrameName.SHALLOW_SEA_FISHING_BOAT
	| FrameName.DEEP_SEA_FISHING_BOAT
	| FrameName.SHALLOW_SEA_BIG_FISHING_BOAT
	| FrameName.DEEP_SEA_BIG_FISHING_BOAT;

class ShallowSeaFishingBoatBuildingTileEntity extends TileEntity {
	public static readonly frameName: FishingBoatFrameNames =
		FrameName.SHALLOW_SEA_FISHING_BOAT;

	public get range(): number | null {
		if (!super.range) return null;

		let range = super.range;

		// Apply upgrades
		range += getUpgradeCurrentReplaceValueById(UpgradeIds.durable_nets);

		return range;
	}
}

export default ShallowSeaFishingBoatBuildingTileEntity;
